import { Throttle } from "@lyse-as/ice-style/ts/00-atoms/00-global/Utils";

const positionBarRelatedToMenu = (control: HTMLElement, mainNav?: HTMLElement) => {
  const mediaQueryList = window.matchMedia(`(min-width: 770px)`);
  const top = mediaQueryList.matches ? "6.25rem" : "4.25rem"; // matches = desktop

  if (mainNav?.classList.contains("show-sticky")) {
    control.style.top = top;
  } else {
    control.style.top = "0.25rem";
  }
};

const startScrollEvent = (segmentControl: HTMLElement) => {
  const mainNav = document.querySelector<HTMLElement>("#js-main-nav")?.parentElement;
  if (!mainNav) {
    return;
  }

  window.addEventListener(
    "scroll",
    Throttle(() => positionBarRelatedToMenu(segmentControl, mainNav), 100),
    { passive: true },
  );
};

export const bootstrapToggleBar = () => {
  const segmentControl = document.querySelector<HTMLElement>(".segment-control--sticky");
  if (segmentControl) {
    startScrollEvent(segmentControl);
  }
};
